import { YouTubeCreatorFlow } from "@/components/exp_YTFlow/YouTubeCreatorFlow";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/flow/")({
  component: YouTubeCreatorFlow,
});
